var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSocialGoogle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6667 9.33333H9.33333V38.6667H38.6667V9.33333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.24 19.8933L27.584 21.8133L29.696 20.2773V31.4133H32V16.8213H30.08L26.24 19.8933Z",
    fill: "#1E88E5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5907 23.66C23.424 22.8947 23.9413 21.8333 23.9413 20.6613C23.9413 18.332 21.8973 16.4373 19.3853 16.4373C17.2493 16.4373 15.4227 17.7827 14.9453 19.708L17.1547 20.2693C17.3747 19.384 18.312 18.7413 19.3853 18.7413C20.6413 18.7413 21.664 19.6027 21.664 20.6613C21.664 21.72 20.6413 22.5813 19.3853 22.5813H18.056V24.8853H19.3853C20.8267 24.8853 22.0427 25.8867 22.0427 27.072C22.0427 28.2773 20.888 29.2587 19.468 29.2587C18.1853 29.2587 17.0893 28.4453 16.916 27.368L14.6667 27.736C15.016 29.9173 17.08 31.5627 19.4667 31.5627C22.1427 31.5627 24.32 29.548 24.32 27.072C24.32 25.708 23.648 24.484 22.5907 23.66Z",
    fill: "#1E88E5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3333 48H10.6667L9.33333 42.6667L10.6667 37.3333H37.3333L38.6667 42.6667L37.3333 48Z",
    fill: "#FBC02D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.6667 38.6667L48 37.3333V10.6667L42.6667 9.33333L37.3333 10.6667V37.3333L42.6667 38.6667Z",
    fill: "#4CAF50"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3333 10.6667L38.6667 5.33333L37.3333 0H4C1.79067 0 0 1.79067 0 4V37.3333L5.33333 38.6667L10.6667 37.3333V10.6667H37.3333Z",
    fill: "#1E88E5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3333 37.3333V48L48 37.3333H37.3333Z",
    fill: "#E53935"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44 0H37.3333V10.6667H48V4C48 1.79067 46.2093 0 44 0Z",
    fill: "#1565C0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4 48H10.6667V37.3333H0V44C0 46.2093 1.79067 48 4 48Z",
    fill: "#1565C0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialGoogle);
export default __webpack_public_path__ + "static/media/social-google.8858637d.svg";
export { ForwardRef as ReactComponent };